import Pickr from '@simonwep/pickr';

document.addEventListener("DOMContentLoaded", (event) => {
    const $color_input = document.querySelector('.js-color-picker');

    const swatches = [
        '#7CD0E4',
        '#BFDA9B',
        '#FFE07D',
        '#F6AC8F',
        '#FBC589',
        '#97CEB5'
    ];
    
    if ( $color_input ) {
    
        const pickr = Pickr.create({
            el: $color_input,
            theme: 'nano',
            default:  swatches[Math.floor(Math.random()*swatches.length)],
            swatches: swatches,
            useAsButton: true,
            components: {
                // Main components
                preview: true,
                opacity: false,
                hue: true, 
                // Input / output Options
                interaction: {
                    input: true,
                    clear: true,
                    save: true
                }
            }
        });   
        
        pickr.on('init', pickr => {
            if ( $color_input.value.length === 0 ) {
                $color_input.value = pickr.getSelectedColor().toHEXA().toString(0);
                $color_input.style.backgroundColor = pickr.getSelectedColor().toHEXA().toString(0);
            }
        }).on('save', color => {
            if ( color ) {
                $color_input.value = color.toHEXA().toString(0);
                $color_input.style.backgroundColor = color.toHEXA().toString(0);
            }
            pickr.hide();
        });
    }
});